export enum LandingPagePermissions {
  ALL = "Travel:LandingPages:*",
  READ = "Travel:LandingPages:Read",
  WRITE = "Travel:LandingPages:Write",
}

export function hasLandingPageAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [LandingPagePermissions.READ, LandingPagePermissions.ALL, "*"].includes(p)
  );
}
